import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Injectable,
} from "@angular/core";
import { UtilService } from "../../shared/services/util.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageServices } from "src/app/shared/services/message.services";
import { ApiService } from "src/app/shared/services/api.service";
import { LabelServices } from "src/app/shared/services/label.services";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { OrderPipe } from "ngx-order-pipe";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  providers: [OrderPipe] // Add this line
})
export class HeaderComponent implements OnInit {
  @Output() toggle: EventEmitter<null> = new EventEmitter();
  userName = localStorage.getItem("name");
  dealerCode = localStorage.getItem("Dealer_code");
  transporterCode = localStorage.getItem("Transporter_code");
  roleId = localStorage.getItem("role_id");
  brand = localStorage.getItem("brand");
  role = localStorage.getItem("role_desc");
  serviceData: any = [];
  helpContent: any = [];
  helpData: any = [];
  roleData: any = [];
  overAllhelpdata: any = [];
  appVersion = '2.2.1';

  constructor(
    private util: UtilService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private message: MessageServices,
    private api: ApiService,
    public label: LabelServices
  ) { }
  ngOnInit() {
    this.brand = localStorage.getItem("brand");
    this.route.data.subscribe((data) => { });
    this.getAllRoles();
  }

  getAllRoles() {
    this.api.getAllroles().subscribe((response) => {
      this.roleData = response;
    });
  }

  checkSession() {
    this.api.checkSession().subscribe((response) => {
    });
  }

  logout() {
    this.brand = localStorage.getItem("brand");
    this.api.logout().subscribe((response) => {
      if (response.code == "0000") {
        if (this.brand == "Nissan") {
          // this.util.startLoader()
          // this.api.logout().subscribe(res =>{
          this.util.stopLoader();
          // if(res.code=="0000"){
          this.util.clearAllLocalStorage();
          this.router.navigate(["/nissan-login"]);
          this.message.success("MP35");
          // }
          // })
        } else if (this.brand == "Renault") {
          // this.util.startLoader()
          // this.api.logout().subscribe(res =>{
          this.util.stopLoader();
          // if(res.code=="0000"){
          this.util.clearAllLocalStorage();
          this.router.navigate(["/renault-login"]);
          this.message.success("MP35");
          //   }
          // })
        } else {
          // this.util.startLoader()
          // this.api.logout().subscribe(res =>{
          this.util.stopLoader();
          // if(res.code=="0000"){
          this.util.clearAllLocalStorage();
          this.router.navigate(["/login"]);
          this.message.success("MP35");
          //   }
          // })
        }
      } else if (response.code == "9999") {
        this.util.stopLoader();
        this.message.error("MP92");
      } else {
        this.util.stopLoader();
        this.util.clearAllLocalStorage();
      }
    });
  }

  currentScreen: any = [];
  selectedId = "";

  openHelp(content) {
    let currentUrl = this.router.url;
    this.util.startLoader();
    this.api.getAllServices().subscribe((res) => {
      this.util.stopLoader();
      if (res != null || res != undefined || res != "") {
        this.serviceData = res;
        this.currentScreen = [];
        this.serviceData.forEach((e) => {
          if (e.path == currentUrl) {
            this.currentScreen.push(e);
          }
        });
        this.selectedId = this.currentScreen[0].screenId;
        this.helpModData();
        this.modalService.open(content, {
          size: "lg",
          windowClass: "help-module",
          backdrop: "static",
          keyboard: false,
        });
      } else {
        this.message.error("MP92");
      }
    });
  }

  relatedLink(h) {
    this.selectedId = h.screenId;
    this.helpModData();
  }

  helpModData() {
    this.util.startLoader();
    this.helpContent = [];
    this.api.getHelp(this.selectedId).subscribe((res) => {
      this.util.stopLoader();
      if (res == null || res == undefined || res == "") {
        this.message.error("MP92");
      } else {
        this.helpContent = res[0];
        this.util.startLoader();
        this.helpData = [];
        this.api.getAllHelp().subscribe((res) => {
          //this.overAllhelpdata = res
          this.util.stopLoader();
          res.forEach((e) => {
            this.roleData.forEach((role) => {
              if (this.roleId == role.roleId) {
                role.screens.forEach((screen) => {
                  if (
                    e.channel == "WEB" &&
                    e.screenId == screen.screenId &&
                    e.screenId != this.helpContent.screenId
                  ) {
                    this.helpData.push(e);
                  }
                });
              }
            });
          });
          res.forEach((s) => {
            if (s.screenType == "COMMON") {
              this.helpData.push(s);
            }
          });
        });
      }
    });
  }
}
